<script>
    import rpcjs from 'rpcjs';
    const {goto} = rpcjs.props;
    let rightDiv = 'rightdiv';
    let leftDiv = 'leftdiv';
    let mainDiv = 'maindiv';
    let gamingDiv = 'gamingText';
    let whyText = 'whyText';
    let startdiv;
    import {onMount} from 'svelte';
    /**
     */
    function onStart() {
        mainDiv = 'maindivAfter';
        whyText = 'whyText2';
        gamingDiv = 'gamingText2';
        startdiv.style.backgroundColor = 'transparent';
    }
    onMount(onMountFunction);
    /**
     */
    function onMountFunction() {
        setTimeout(onStart, 10);
    }
    /**
     * Adds two numbers together.
     */
    function next() {
        gamingDiv = 'gamingTextAfter';
        leftDiv = 'leftdivAfter';
        rightDiv = 'rightdivAfter';
        setTimeout(() => {
            goto('/gamingImpact');
        }, 1000);
    }
    /**
     * Adds two numbers together.
     * @param {int} e The first number.
     */
    function keycheck(e) {
        e.preventDefault();
        if (e.key == 'ArrowRight') {
            next();
        }
        if (e.key == 'ArrowLeft') {
            goto('solution');
        }
    }
</script>

<svelte:window on:keyup={keycheck} />
<div
    class="startdiv"
    bind:this={startdiv}
    role="presentation"
    on:click={next}
/>
<div style="height: 100vh; background-color: #101428; width:100%">
    <div class={mainDiv}>
        <div class={leftDiv}>
            <div class="leftImg">
                <img
                    src="/images/whygaming/left.png"
                    alt=""
                    class="left-half"
                />
            </div>
            <div class="{whyText} why-text">
                <p>WHY</p>
            </div>
        </div>

        <div class={rightDiv}>
            <div class="rightImg">
                <img
                    src="/images/whygaming/right.png"
                    alt=""
                    class="right-half"
                />
            </div>
        </div>
        <div class="{gamingDiv} gaming-text">
            <p>GAMING?</p>
        </div>
    </div>
</div>

<style>
    img.left-half {
        object-fit: cover;
        width: 100%;
        height: 100%;
        object-position: right;
    }
    img.right-half {
        object-fit: cover;
        width: 100%;
        height: 100%;
        object-position: left;
    }
    .startdiv {
        position: absolute;
        background-color: #101428;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        top: 0;
        left: 0vw;
        z-index: 4;
        transition-duration: 0.5s;
    }
    p {
        margin: 0;
        font-family: "Montserrat";
    }
    .maindiv {
        position: relative;
        display: flex;
        overflow: hidden;
        height: 100vh;
        scale: 0.7;
        background-color: #101428;
        transition-duration: 1s;
    }
    .maindivAfter {
        position: relative;
        display: flex;
        overflow: hidden;
        height: 100vh;
        scale: 1;
        background-color: #101428;
        transition-duration: 1.5s;
    }
    .leftdivAfter {
        position: relative;
        left: -50vw;
        transition-duration: 1.5s;
    }
    .leftdiv {
        position: relative;
        transition-duration: 1.5s;
        left: 0vw;
    }
    .leftImg {
        width: 50.052vw;
        height: 100vh;
    }
    .whyText {
        scale: 0.8;
        left: -10vw;
        transition-duration: 1.5s;
    }
    .whyText2 {
        scale: 1;
        left: 0vw;
        z-index: 1;
    }
    div.why-text {
        position: absolute;
        font-size: min(27.778vh, 29.367vw);
        color: white;
        font-weight: 900;
        top: 56.5vh;
        transition-duration: 1.5s;
    }
    .gamingTextAfter {
        left: 100vw;
    }
    .gamingText {
        left: -10vw;
        scale: 0.8;
    }
    .gamingText2 {
        left: 0vw;
        scale: 1;
    }
    div.gaming-text {
        position: absolute;
        font-weight: 900;
        font-size: min(18.519vh, 19.578vw);
        color: #ffcc33;
        top: 80.444vh;
        transition-duration: 1.5s;
    }
    .rightdivAfter {
        position: relative;
        left: 50vw;
        transition-duration: 1.5s;
    }
    .rightdiv {
        position: relative;
        left: 0vw;
        transition-duration: 1.5s;
    }
    .rightImg {
        width: 50.052vw;
        height: 100vh;
    }
</style>
